export default "__VITE_ASSET__55563f7e__"